import { isDevelopment } from './env';

export const protocol = isDevelopment ? 'http' : 'https';
